import {
  Box,
  Button,
  Menu,
  MenuItem,
  Tab,
  TableCell,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { styles } from "./style";
import ApplyCreditsToInvoices from "../../../../../../modals/ApplyToInvoiceModal";
import RefundModal from "../../../../../../modals/RefundModal";
import dropDownIcon from "../../../../../../assets/AccountingModule/dropdown_black.svg";
import deleteIcon from "../../../../../../assets/AccountingModule/delete.svg";
import editIcon from "../../../../../../assets/AccountingModule/edit2.svg";
import { useLocation } from "react-router-dom";
import { formatDate } from "../../../../../../utils/DateFormat";

const ViewNotes = ({
  handleShowPdf,
  handleDownloadReceipt,
  handleApplyToInvoices,
  getEditNotesData,
  editNoteData,
  getInvoiceList,
  invoicesList,
  bankData,
  handleRefundSubmit,
  handleSendNote,
  deleteCreditApply,
  deleteRefundHistory,
}) => {
  const [billHtml, setBillHtml] = useState("");
  const [applyToInvoicesOpen, setApplyToInvoicesOpen] = useState(false);
  const [refundModalOpen, setRefundModalOpen] = useState(false);
  const [isTableVisible, setIsTableVisible] = useState(true);
  const [editingRefund, setEditingRefund] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const { item } = useLocation().state || {};
  const creditNote = editNoteData || [];
  const refundData = editNoteData || [];
  const appliednotes = editNoteData?.invoice || [];
  const refundHistoryData = editNoteData?.refund || [];

  useEffect(() => {
    const fetchShowPdfHtml = async () => {
      const result = await handleShowPdf();
      setBillHtml(result.__html);
    };
    fetchShowPdfHtml();
  }, [handleShowPdf]);

  useEffect(() => {
    if (item?._id) {
      getEditNotesData(item._id);
      getInvoiceList(item?.customer._id);
    }
  }, []);

  const handleRefund = (refundItem = null) => {
    setEditingRefund(refundItem);
    setRefundModalOpen(true);
  };

  const handleCloseRefund = () => {
    setRefundModalOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setIsTableVisible(false);
  };

  const renderCreditApplyNotes = () => (
    <Box sx={styles.paymentSection}>
      <Box sx={styles.paymentHeader}>
        <Box sx={styles.paymentTitleContainer}>
          <Typography sx={styles.paymentTitle}>Payments Received</Typography>
          <Typography sx={styles.paymentCount}>
            {editNoteData?.invoice?.length}
          </Typography>
        </Box>
        <Box>
          <button
            type="button"
            style={styles.dropDownButton}
            aria-label="Open payment options"
            onClick={() => setIsTableVisible((prev) => !prev)}
          >
            <img
              src={dropDownIcon}
              alt="Dropdown Icon"
              style={{
                transform: isTableVisible ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            />
          </button>
        </Box>
      </Box>
      {isTableVisible && (
        <Box sx={{ overflowX: "auto" }}>
          <table>
            <thead
              style={{
                background: "transparent !important",
                borderBottom: "1px solid #D9D9D9",
              }}
            >
              <tr>
                <th
                  style={{
                    ...styles.tableHeader,
                    backgroundColor: "transparent",
                  }}
                >
                  Date
                </th>
                <th
                  style={{
                    ...styles.tableHeader,
                    backgroundColor: "transparent",
                  }}
                >
                  Invoice Number
                </th>
                <th
                  style={{
                    ...styles.tableHeader,
                    backgroundColor: "transparent",
                  }}
                >
                  Amount Credited
                </th>
                <th
                  style={{
                    ...styles.tableHeader,
                    backgroundColor: "transparent",
                  }}
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {appliednotes.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography variant="h6">No Data</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                appliednotes.map((item, index) => (
                  <tr key={index}>
                    <td style={{ ...styles.tableCell, borderBottom: "none" }}>
                      {item?.date
                        ? formatDate(item?.date)
                        : "N/A"}
                    </td>
                    <td style={{ ...styles.tableCell, borderBottom: "none" }}>
                      {item?.invoiceNo || "N/A"}
                    </td>
                    <td style={{ ...styles.tableCell, borderBottom: "none" }}>
                      {item?.amount || "N/A"}
                    </td>
                    <td style={{ ...styles.tableCell, borderBottom: "none" }}>
                      <Box>
                        <Button
                          type="button"
                          sx={{ backgroundColor: "transparent" }}
                          onClick={() => {
                            deleteCreditApply(
                              editNoteData?._id,
                              item?.creditAppliedID
                            );
                          }}
                        >
                          <img
                            src={deleteIcon}
                            alt="Delete"
                            style={{ marginRight: "8px" }}
                          />
                        </Button>
                      </Box>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </Box>
      )}
    </Box>
  );

  const renderRefundHistory = () => (
    <Box sx={styles.paymentSection}>
      <Box sx={styles.paymentHeader}>
        <Box sx={styles.paymentTitleContainer}>
          <Typography sx={styles.paymentTitle}>Refund History</Typography>
          <Typography sx={styles.paymentCount}>
            {refundHistoryData?.length || 0}
          </Typography>
        </Box>
        <Box>
          <button
            type="button"
            style={styles.dropDownButton}
            aria-label="Open refund history"
            onClick={() => setIsTableVisible((prev) => !prev)}
          >
            <img
              src={dropDownIcon}
              alt="Dropdown Icon"
              style={{
                transform: isTableVisible ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            />
          </button>
        </Box>
      </Box>
      {isTableVisible && (
        <Box sx={{ overflowX: "auto" }}>
          <table>
            <thead
              style={{
                background: "transparent !important",
                borderBottom: "1px solid #D9D9D9",
              }}
            >
              <tr>
                <th
                  style={{
                    ...styles.tableHeader,
                    backgroundColor: "transparent",
                  }}
                >
                  Date
                </th>
                <th
                  style={{
                    ...styles.tableHeader,
                    backgroundColor: "transparent",
                  }}
                >
                  Payment Mode
                </th>
                <th
                  style={{
                    ...styles.tableHeader,
                    backgroundColor: "transparent",
                  }}
                >
                  Amount Refunded
                </th>
                <th
                  style={{
                    ...styles.tableHeader,
                    backgroundColor: "transparent",
                    pl: 5
                  }}
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {refundHistoryData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography variant="h6">No Data</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                refundHistoryData.map((item, index) => (
                  <tr key={index}>
                    <td style={{ ...styles.tableCell, borderBottom: "none" }}>
                      {item?.date
                        ? formatDate(item?.date)
                        : "N/A"}
                    </td>
                    <td style={{ ...styles.tableCell, borderBottom: "none" }}>
                      {item?.paymentMethod || "N/A"}
                    </td>
                    <td style={{ ...styles.tableCell, borderBottom: "none" }}>
                      {item?.amount || "N/A"}
                    </td>
                    <td
                      style={{
                        ...styles.tableCellButton,
                        borderBottom: "none",
                      }}
                    >
                      <Button
                        type="button"
                        sx={{
                          backgroundColor: "transparent",
                          paddingRight: "0px",
                        }}
                        onClick={() => handleRefund(item)}
                      >
                        <img src={editIcon} alt="Edit" />
                      </Button>
                      <Button
                        type="button"
                        sx={{
                          backgroundColor: "transparent",
                          marginLeft: "-10px",
                        }}
                        onClick={() => {
                          deleteRefundHistory(
                            editNoteData?._id,
                            item?.transactionId
                          );
                        }}
                      >
                        <img src={deleteIcon} alt="Delete" />
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </Box>
      )}
    </Box>
  );

  useEffect(() => {
    if (activeTab === 0 || activeTab === 1) {
      setIsTableVisible((prev) => !prev);
    }
  }, [activeTab]);
  return (
    <>
      <Box sx={{ ml: 2, display: "flex", justifyContent: "flex-end", mt: 1 }}>
        <Box sx={{ mr: 2 }}>
          <Button
            variant="contained"
            color="success"
            sx={styles.csvBtns}
            onClick={handleDownloadReceipt}
          >
            {"Download"}
          </Button>
          <Button
            variant="contained"
            color="success"
            sx={{ ...styles.checkinBtns, borderLeft: "1px solid #fff" }}
            onClick={handleSendNote}
          >
            {"Send Note"}
          </Button>
          <Button
            variant="contained"
            color="success"
            sx={styles.checkinBtns}
            onClick={() => setApplyToInvoicesOpen(true)}
          >
            {"Apply to Invoices"}
          </Button>
          <Button
            variant="contained"
            color="success"
            sx={styles.checkinRefundBtns}
            onClick={() => handleRefund()}
          >
            {"Refund"}
          </Button>
        </Box>
      </Box>
      <Box sx={{ ml: 2, mr: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="credit and refund tabs"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#4CAF50",
            },
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 700,
              border: "none",
              "&.Mui-selected": {
                color: "#4CAF50",
              },
            },
          }}
        >
          <Tab label="Credit Apply Notes" />
          <Tab label="Refund History" />
        </Tabs>
      </Box>
      <Box sx={{ mt: 2 }}>
        {activeTab === 0 && renderCreditApplyNotes()}
        {activeTab === 1 && renderRefundHistory()}
      </Box>
      <Box sx={styles.whiteSection}>
        <Box dangerouslySetInnerHTML={{ __html: billHtml }} />
      </Box>
      <ApplyCreditsToInvoices
        open={applyToInvoicesOpen}
        setOpen={setApplyToInvoicesOpen}
        creditNote={creditNote}
        loading={false}
        handleApply={handleApplyToInvoices}
        invoicesList={invoicesList}
        item={item}
        getInvoiceList={getInvoiceList}
      />
      <RefundModal
        open={refundModalOpen}
        onClose={handleCloseRefund}
        refundData={refundData}
        handleRefundSubmit={handleRefundSubmit}
        bankData={bankData}
        editingRefund={editingRefund}
      />
    </>
  );
};

export default ViewNotes;
